<template>
  <div class="form-page form-application">
    <div class="full-frame-container">
      <div class="container">

        <!-- Login Form -->
        <div class="form-box">
          <div class="column-left">
            <b-img class="d-block logo" src="@/assets/logo_text.png"></b-img>
          </div>
          <div class="column-right">
            <div class="">
              <div class="form-container">
                <div class="header-description">
                  <h3 class="mb-2">HELLO!</h3>
                  <h4 class="mb-4">Let's get your company started.</h4>
                </div>
                  <input
                    v-model="username"
                    type="text"
                    placeholder="Username (e.g. user_company_name)"
                    class="form-control"
                    autocomplete="username"
                    @input="showError = false; accountError = ''"
                  />

                  <div class="password-wrapper mt-4">
                    <input
                      v-model="password"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Password"
                      class="form-control"
                      autocomplete="current-password"
                      @input="showError = false"
                    />
                    <button
                      type="button"
                      class="toggle-password"
                      @click="togglePassword"
                    >
                      <fa-icon :icon="showPassword ? ['fas', 'eye'] : ['fas', 'eye-slash']" />
                    </button>
                  </div>
                  <div
                    class="forgot-password text-right font-weight-normal text-sm text-goldenrod"
                    @click="goToForgotPassword"
                  >
                    Forgot password
                  </div>

                  <div class="d-flex justify-content-center mt-5">
                      <button @click="handleSubmit" class="btn btn-submit px-5 py-2" type="submit"
                      :disabled="!username.trim() || !password">
                      Login
                      </button>
                  </div>

                  <!-- Error Message -->
                  <p v-if="showError" class="error-msg mt-2 text-center">
                    Incorrect username or password.<br>Please try again or click forgot password.
                  </p>
                  <div v-if="accountError" class="account-blocked-msg mt-2 text-center">
                    <fa-icon :icon="['fas', 'exclamation-circle']" class="account-blocked-icon" />
                    <span>{{ accountError }}</span>
                  </div>
              </div>
            </div>
            <div class="mt-2 text-center">
              <p class="font-weight-normal text-sm">
                Don't have an account? <router-link :to="`/${$i18n.locale}/contact-us?type=2`" class="text-goldenrod">Contact us here</router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="copyright text-xs font-weight-light">Copyright © 2020 TYNG & CO (NF 2148)</div>
      </div>
    </div>
  </div>
</template>

<script>
import { encryptPassword } from '@/services/crypto'

export default {
  name: 'login',
  metaInfo () {
    const title = 'Tyng & Co | Login'
    const description = 'Register New Company'
    document.querySelector('meta[name="description"]').content = description
    return {
      title,
      titleTemplate: null,
      meta: [{ vmid: 'description', name: 'description', content: description }],
      link: [{ rel: 'canonical', href: `https://tyng-ca.com.my/${this.$i18n.locale}/login` }]
    }
  },
  data () {
    return {
      username: '',
      password: '',
      showError: false,
      accountError: '',
      showPassword: false
    }
  },
  mounted () {
    if (localStorage.getItem('client_access_token')) {
      this.$router.push(`/${this.$i18n.locale}/user-panel`)
    }
  },
  methods: {
    goToForgotPassword () {
      this.$router.push(`/${this.$i18n.locale}/reset-password`)
    },

    togglePassword () {
      this.showPassword = !this.showPassword
    },

    async handleSubmit () {
      const inputUsername = this.username.trim()
      const inputPassword = this.password.trim()

      this.showError = false
      this.accountError = ''

      if (!inputUsername || !inputPassword) return

      try {
        const encryptedPassword = await encryptPassword(inputPassword)
        const res = await fetch('https://tyng-ca.com.my/api/client/login.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: inputUsername, encrypted_password: encryptedPassword })
        })

        const data = await res.json()

        if (data.success) {
          localStorage.setItem('client_access_token', data.token)
          localStorage.setItem('client_refresh_token', data.refresh_token)
          localStorage.setItem('client_user', JSON.stringify(data.client))
          this.$router.push(`/${this.$i18n.locale}/user-panel`)
        } else if (res.status === 403) {
          this.accountError = data.message
        } else {
          this.showError = true
        }
      } catch (err) {
        console.error('Login error:', err)
        this.showError = true
      }
    }
  }
}
</script>
